module.exports = __webpack_public_path__ + "img/10.415f3557.jpg";